// extracted by mini-css-extract-plugin
export default {"tagband":"Principles_tagband__oOUd0"};